import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import NormalLevelBase from "./LevelBase";


const { ccclass, property, menu, disallowMultiple } = cc._decorator;

@ccclass
@disallowMultiple
export default class InGamePage extends BasePopUpLayer {

    @property(cc.Label)
    labelTitle: cc.Label = null;

    private _parent: NormalLevelBase = null;


    setData(_parent: NormalLevelBase, strTitle: string) {
        this._parent = _parent;
        this.labelTitle.string = strTitle;
    }
  
    OnTipsBtn() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this._parent.OnTips();
    }

    onClickClose() {
        this._parent.exitLayer();
        O1HD.getManagers().soundMgr.playSound('anNiu');
    }
}